/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnLevel } from './en-level';
import { EnUserAffectedSide } from './en-user-affected-side';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UserPathologyDto
 */
export interface UserPathologyDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof UserPathologyDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserPathologyDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserPathologyDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof UserPathologyDto
     */
    deleted: string | null;

    /**
     * @type {boolean}
     * @memberof UserPathologyDto
     */
    comorbidity: boolean;

    /**
     * @type {boolean}
     * @memberof UserPathologyDto
     */
    chronic: boolean;

    /**
     * @type {boolean}
     * @memberof UserPathologyDto
     */
    acute: boolean;

    /**
     * @type {string}
     * @memberof UserPathologyDto
     */
    start: string;

    /**
     * @type {EnUserAffectedSide}
     * @memberof UserPathologyDto
     */
    affectedSide: EnUserAffectedSide | null;

    /**
     * @type {EnLevel}
     * @memberof UserPathologyDto
     */
    level: EnLevel | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UserPathologyDto
     */
    user: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof UserPathologyDto
     */
    pathology: JoinEntityDto;

    /**
     * The practitioner who assigned this pathology (audit).
     *
     * @type {JoinEntityDto}
     * @memberof UserPathologyDto
     */
    creator: JoinEntityDto | null;
}
